import React from 'react';

import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Box from '@material-ui/core/Box';

import useAppBar from 'components/AppBar/useAppBar';
import PaperLogin from './components/PaperLogin';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import useAuth from 'components/Auth/useAuth';
import { useHistory } from 'react-router';
import Naviee from 'components/Logo/Naviee';

const useStyles = makeStyles((theme) => ({
  container: {
    margin: 'auto',
    maxWidth: '1200px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(8),
    },
  },
  message: {
    fontSize: '40px',
    fontWeight: 'bold',
    textAlign: 'left',
  },
  paper: {
    padding: '0 1.5vw',
    width: '100%',
  },
  image: {
    height: '263px',
  },
}));

export default function Home(props)
{
  useAppBar("", [], true);

  const auth = useAuth();
  const history = useHistory();
  React.useEffect(() => {
    if (auth.isUser) {
      history.push("/inbox");
    }
  }, [auth]);

  const classes = useStyles();
  const upLg = useMediaQuery(theme => theme.breakpoints.up("lg"));

  return (
    <div className={classes.container}>
    <Grid container>
      <Grid item md={12} lg={5} className={classes.paper}>
        <PaperLogin />
      </Grid>
      <Grid item md={12} lg={1} />
      { upLg ? 
        <Grid item md={12} lg={6}>
          <Box m={upLg ? 25 : 1} />
          <div><Typography className={classes.message}>閲覧にはログインまたは、</Typography></div>
          <div><Typography className={classes.message}>アカウント新規登録が必要です。</Typography></div>
          <Box m={10} />
          <Naviee className={classes.image} />
        </Grid> : null
      }
    </Grid>
    </div>
  )
}